import React, { useState } from 'react';
import { FiActivity, FiChevronDown, FiChevronUp, FiCheck, FiX, FiLoader } from 'react-icons/fi';
import ProgressBar from './ProgressBar';
import { useOperations } from '../../contexts/OperationsContext';

const ActiveOperations: React.FC = () => {
  const { operations } = useOperations();
  const [expanded, setExpanded] = useState(true);
  const [dismissed, setDismissed] = useState<Set<string>>(new Set());

  const activeOps = operations.filter(
    (op) => {
      if (op.status === 'running') return true;
      if (op.completedAt && Date.now() - op.completedAt.getTime() < 30000) return true;
      return false;
    }
  ).filter((op) => !dismissed.has(op.id));

  if (activeOps.length === 0) return null;

  const runningCount = activeOps.filter((op) => op.status === 'running').length;

  return (
    <div className="active-ops-panel">
      <div className="active-ops-header" onClick={() => setExpanded(!expanded)}>
        <div className="active-ops-title">
          {runningCount > 0 && <FiLoader className="spin" size={14} />}
          <span>
            {runningCount > 0
              ? `${runningCount} operacj${runningCount === 1 ? 'a' : runningCount < 5 ? 'e' : 'i'} w toku`
              : 'Operacje zakończone'}
          </span>
        </div>
        {expanded ? <FiChevronDown size={14} /> : <FiChevronUp size={14} />}
      </div>

      {expanded && (
        <div className="active-ops-body">
          {activeOps.map((op) => (
            <div key={op.id} className={`active-op-item active-op-${op.status}`}>
              <div className="active-op-header">
                <div className="active-op-label">
                  {op.status === 'running' && <FiLoader className="spin" size={12} />}
                  {op.status === 'completed' && <FiCheck size={12} className="text-success" />}
                  {op.status === 'failed' && <FiX size={12} className="text-danger" />}
                  <span>{op.label}</span>
                </div>
                {op.status !== 'running' && (
                  <button
                    className="active-op-dismiss"
                    onClick={() => setDismissed((prev) => new Set(prev).add(op.id))}
                  >
                    <FiX size={12} />
                  </button>
                )}
              </div>

              {op.status === 'running' && (
                <>
                  <ProgressBar
                    current={op.progress.current}
                    total={op.progress.total}
                    size="sm"
                    showPercentage={true}
                    showCount={true}
                  />
                  {op.currentItem && (
                    <div className="active-op-current">
                      <FiActivity size={10} /> {op.currentItem}
                    </div>
                  )}
                </>
              )}

              {op.status === 'completed' && op.result && (
                <div className="active-op-result">
                  <span className="text-success">{op.result.success} ok</span>
                  {op.result.failed > 0 && (
                    <span className="text-danger">{op.result.failed} błędów</span>
                  )}
                </div>
              )}

              {op.status === 'failed' && (
                <div className="active-op-result">
                  <span className="text-danger">Operacja nieudana</span>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ActiveOperations;
